export default "__VITE_ASSET__DYyDUHg___"